import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import RichText from "./RichText";

function NarrowTextColumn({ text }) {
  return (
    <Box
      pb={[50, null, 80, null]}
      px={[null, null, null, "7.75vw"]}
      display="flex"
      justifyContent="flex-end"
    >
      <Box maxWidth={630}>
        <RichText>{text}</RichText>
      </Box>
    </Box>
  );
}

NarrowTextColumn.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NarrowTextColumn;
